module.exports = __webpack_public_path__ + "static/media/recuerda.a6ef5999.svg";